import { isEmpty } from 'lodash';
import { Injectable } from '@angular/core';
import { AsyncValidatorFn, FormArray, FormGroup } from '@angular/forms';
import { DeviceUser } from '@core/models/device-user';
import { MyDeviceFormControlName } from '../models';
import {
  MyDevicesFormBuilderService,
  MyDevicesFormState
} from '../types/my-devices-form-builder-service.type';
import { NewDeviceRegistrationFormService } from './new-device-registration-form.service';

@Injectable({
  providedIn: 'any'
})
export class RegistrationDeviceFormService implements MyDevicesFormBuilderService {
  constructor(
    private readonly newDeviceRegistrationFormService: NewDeviceRegistrationFormService
  ) {}

  initForm(devices: DeviceUser[] | undefined, formState: MyDevicesFormState): FormGroup {
    return new FormGroup({
      [MyDeviceFormControlName.REGISTERED_DEVICES]: new FormArray([]),
      [MyDeviceFormControlName.NEW_DEVICES]: new FormArray(
        this.buildDevicesFormControl(formState, devices)
      )
    });
  }

  configureForm(form: FormGroup) {
    if (!form) {
      return;
    }
  }

  private buildDevicesFormControl(
    formState: MyDevicesFormState,
    devices: DeviceUser[] | undefined
  ): FormGroup[] {
    if (!devices || isEmpty(devices)) {
      return [this.buildSerialFormControlForDevices(formState)];
    }

    return devices!.map((device) =>
      this.buildSerialFormControlForDevices(formState, device.serial, device.passphrase)
    );
  }

  private buildSerialFormControlForDevices(
    formState: MyDevicesFormState,
    serial?: string,
    passphrase?: string
  ): FormGroup {
    return this.newDeviceRegistrationFormService.buildNewDeviceFormGroup(
      formState,
      serial,
      passphrase
    );
  }
}
